module.exports = __webpack_public_path__ + "img/xcx_qr.6f240166.jpg";